export const FETCH_NDT_ANALYTICS = 'FETCH_NDT_ANALYTICS';
export const FETCH_NDT_ANALYTICS_SUCCESS = 'FETCH_NDT_ANALYTICS_SUCCESS';
export const FETCH_NDT_ANALYTICS_FAILURE = 'FETCH_NDT_ANALYTICS_FAILURE';
export const FETCH_AI_INSIGHTS = 'FETCH_AI_INSIGHTS';
export const FETCH_AI_INSIGHTS_SUCCESS = 'FETCH_AI_INSIGHTS_SUCCESS';
export const FETCH_AI_INSIGHTS_FAILURE = 'FETCH_AI_INSIGHTS_FAILURE';
export const CLEAR_NDT_ANALYTICS = 'CLEAR_NDT_ANALYTICS';

